import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'react-native-paper';

import { ArrowOutwardIcon, DeleteIcon, EditIcon, ForumIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type PostCreatorActionsProps = {
  onItemPress: () => void;
  handleSharePost: () => void;
  handleDelete: () => void;
  handleEdit: () => void;
  handleChat?: () => void;
  chatDisabled?: boolean;
  withdrawInsteadOfDelete: boolean;
};

export const PostCreatorActions: FC<PostCreatorActionsProps> = ({
  onItemPress,
  handleSharePost,
  handleDelete,
  handleEdit,
  handleChat,
  chatDisabled = false,
  withdrawInsteadOfDelete = false
}) => {
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'screens.post-detail.menu'
  });
  const theme = useAppTheme();

  return (
    <>
      {handleChat && (
        <Menu.Item
          disabled={chatDisabled}
          leadingIcon={({ color, size }) => (
            <ForumIcon fill={color} width={size} height={size} />
          )}
          title={t('startChat')}
          onPress={() => {
            handleChat();
            onItemPress();
          }}
        />
      )}
      <Menu.Item
        leadingIcon={({ color, size }) => (
          <EditIcon fill={color} width={size} height={size} />
        )}
        title={t('edit')}
        onPress={() => {
          handleEdit();
          onItemPress();
        }}
      />
      <Menu.Item
        theme={{ colors: { onSurface: theme.colors.error } }}
        leadingIcon={({ size }) => (
          <DeleteIcon fill={theme.colors.error} width={size} height={size} />
        )}
        title={withdrawInsteadOfDelete ? t('withdraw') : t('delete')}
        onPress={() => {
          handleDelete();
          onItemPress();
        }}
      />
      <Menu.Item
        leadingIcon={({ color, size }) => (
          <ArrowOutwardIcon fill={color} width={size} height={size} />
        )}
        title={t('share')}
        onPress={() => {
          handleSharePost();
          onItemPress();
        }}
      />
    </>
  );
};
